
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 18a8 8 0 110-16 8 8 0 010 16zm-2.8-6.4v1.6h2v1.6h1.6v-1.6h.8a2 2 0 000-4H8.4a.4.4 0 110-.8h4.4V6.8h-2V5.2H9.2v1.6h-.8a2 2 0 100 4h3.2a.4.4 0 110 .8H7.2z","fill":"#94A3B8"}})])
          )
        }
      }
    